
jQuery(document).ready(function ($) { 
  if ($(".klaviyo-formadd_to_cart").length) {
        var klaviyoformid = $(".klaviyo-formadd_to_cart").data("klaviyoformid");
        var klaviyoproductid = $(".klaviyo-formadd_to_cart").data(
          "klaviyoproductid"
        );
        var klaviyoproductquantity = $(".klaviyo-formadd_to_cart").data(
          "klaviyoproductquantity"
        );
    
        if (klaviyoformid && klaviyoproductid) {
            var selector =
              '.klaviyo-form[data-testid="klaviyo-form-' +
              klaviyoformid +
              '"] button';
        
            $(document).on("click", selector, function (e) {
              e.preventDefault();
              fetch("/cart/add.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Accept: "application/json",
                },
                body: JSON.stringify({
                  id: klaviyoproductid,
                  quantity: klaviyoproductquantity,
                }),
              })
                .then((response) => response.json())
                .then((data) => {
                  refreshCart();
                  console.log(data);
                })
                .catch((error) => {
                  console.error("Error:", error);
                });
            });
        }
      }
    });
